import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import styles from "./styles.module.scss";
const GainfulToggle = ({ text, callbacks }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const handleClick = (index) => {
        setActiveIndex(index);
        callbacks[index]();
    };
    return (_jsxs("div", { className: styles.togglewrap, children: [_jsx("div", { className: `${styles.toggleButton} ${activeIndex == 0 ? styles.active : ""}`, onClick: () => handleClick(0), children: text[0] }), _jsx("div", { className: `${styles.toggleButton} ${activeIndex == 1 ? styles.active : ""}`, onClick: () => handleClick(1), children: text[1] })] }));
};
export default GainfulToggle;
